import React from 'react';
import { Box, Paper } from '@mui/material';
// eslint-disable-next-line no-restricted-syntax -- DS RadioGroup's closed `options` API can't render the custom Paper-card layout below; grouping semantics only, no styling escape.
import { RadioGroup } from '@mui/material';
import { Checkbox, Radio, Typography } from '@sm-dashboard/ui-components';
import { PUBLISHER_REGULATIONS } from '../../../../../constants/businessAds.constants';

const paymentPlans = [
  {
    value: 'yearly',
    label: '12 חודשים',
    price: '120 ₪ לחודש · חודשיים מתנת הצטרפות · סה״כ 1,200 ₪ + מע״מ',
    recommended: true
  },
  {
    value: 'half-yearly',
    label: '6 חודשים',
    price: '150 ₪ לחודש · חודש מתנת הצטרפות · סה״כ 750 ₪ + מע״מ',
    recommended: false
  },
  { value: 'monthly', label: '3 חודשים', price: '180 ₪ לחודש · סה״כ 540 ₪ + מע״מ', recommended: false }
];

interface PaymentPlanSelectorProps {
  selectedPlan: string;
  setSelectedPlan: (plan: string) => void;
  agreed: boolean;
  setAgreed: (agreed: boolean) => void;
}

const PaymentPlanSelector: React.FC<PaymentPlanSelectorProps> = ({
  selectedPlan,
  setSelectedPlan,
  agreed,
  setAgreed
}) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ mb: '0.35em' }}>
        <Typography variant="h6">בחירת תכנית פרסום</Typography>
      </Box>
      <RadioGroup
        aria-labelledby="payment-plan-group-label"
        name="payment-plan-group"
        value={selectedPlan}
        onChange={e => setSelectedPlan(e.target.value)}
      >
        {paymentPlans.map(plan => (
          <Paper
            key={plan.value}
            variant="outlined"
            sx={{
              p: 2,
              mb: 2,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              ...(plan.recommended && {
                backgroundColor: '#e3f2fd',
                border: '2px solid #2196f3',
                boxShadow: '0 2px 8px rgba(33, 150, 243, 0.2)'
              })
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Radio value={plan.value} label={plan.label} />
              {plan.recommended && (
                <Box
                  sx={{
                    backgroundColor: '#2196f3',
                    color: 'white',
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 1,
                    fontWeight: 'bold',
                    fontSize: '0.75rem'
                  }}
                >
                  מומלץ
                </Box>
              )}
            </Box>
            <Box sx={{ fontWeight: plan.recommended ? 'bold' : 'normal', fontSize: '1rem' }}>{plan.price}</Box>
          </Paper>
        ))}
      </RadioGroup>

      <Box sx={{ mt: 4 }}>
        <Box sx={{ mb: '0.35em' }}>
          <Typography variant="h6">תקנון</Typography>
        </Box>
        <Box
          sx={{
            my: 3,
            p: 3,
            border: '1px solid #ddd',
            borderRadius: 1,
            backgroundColor: '#f9f9f9',
            maxHeight: '400px',
            overflowY: 'auto'
          }}
        >
          <Box
            component="pre"
            sx={{
              whiteSpace: 'pre-wrap',
              fontFamily: 'inherit',
              fontSize: '0.875rem',
              margin: 0
            }}
          >
            {PUBLISHER_REGULATIONS}
          </Box>
        </Box>

        <Checkbox checked={agreed} onChange={e => setAgreed(e.target.checked)} label="קראתי את התקנון ואני מאשר/ת" />

        <Box
          sx={{
            mt: 3,
            p: 2,
            backgroundColor: '#e3f2fd',
            borderRadius: 1,
            border: '1px solid #2196f3'
          }}
        >
          <Box sx={{ fontWeight: 500, textAlign: 'center', fontSize: '1rem' }}>
            החיוב יבוצע לאחר אישור המודעה ע"י הנהלת המערכת
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentPlanSelector;
